module.exports = __webpack_public_path__ + "img/positivo-nero.b23919bb.png";